
/**
 * vue-dynamic-star-rating
 * A Highly Customizable, easy-to-use elegant stars rating component (similar to Google Play)
 * ![MIT License](https://badgen.net/badge/license/MIT/blue "MIT License")
 * [![view on npm](http://img.shields.io/npm/v/vue-dynamic-star-rating.svg?colorB=red)](
 * https://www.npmjs.org/package/vue-dynamic-star-rating)
 * url: https://github.com/JonathanDn/vue-stars-rating.git
 * */
export default {
  name: 'stars-rating',
  components: {},
  props: {
    rating: {
      type: Number,
      default: 4.3,
    },
    starStyle: {
      type: Object,
      default() { return {}; },
    },
    isIndicatorActive: {
      type: Boolean,
      default: true,
    },
    isWhite: {
      type: Boolean,
      default: false,
    },
    isBlack: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      emptyStar: 0,
      fullStar: 1,
      totalStars: 5,
      // Binded Nested Props registered as data/computed and not props
      defaultStyles: {
        starWidth: 100,
        starHeight: 100,
        emptyStarColor: this.$cp.color31,
        fullStarColor: this.$cp.primary_support,
      },
    };
  },
  directives: {},
  computed: {
    allStyles() {
      return {
        ...this.defaultStyles,
        ...this.starStyle,
      };
    },
    getStarPoints() {
      const centerX = this.allStyles.starWidth / 2;
      const centerY = this.allStyles.starWidth / 2;

      const innerCircleArms = 5; // a 5 arms star

      const innerRadius = this.allStyles.starWidth / innerCircleArms;
      const innerOuterRadiusRatio = 2.2; // Unique value - determines fatness/sharpness of star
      const outerRadius = innerRadius * innerOuterRadiusRatio;

      return this.calcStarPoints(
        centerX,
        centerY,
        innerCircleArms,
        innerRadius,
        outerRadius,
      );
    },
    stars() {
      const result = this.initStars();
      return this.setStars(result);
    },
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
  },
  methods: {
    calcStarPoints(
      centerX,
      centerY,
      innerCircleArms,
      innerRadius,
      outerRadius,
    ) {
      const angle = Math.PI / innerCircleArms;
      const angleOffsetToCenterStar = 60;

      const totalArms = innerCircleArms * 2;
      let points = '';
      for (let i = 0; i < totalArms; i += 1) {
        const isEvenIndex = i % 2 === 0;
        const r = isEvenIndex ? outerRadius : innerRadius;
        const currX = centerX + Math.cos(i * angle + angleOffsetToCenterStar) * r;
        const currY = centerY + Math.sin(i * angle + angleOffsetToCenterStar) * r;
        points += `${currX},${currY} `;
      }
      return points;
    },
    initStars() {
      return Array.from(Array(this.totalStars).keys()).map(() => ({
        raw: this.emptyStar,
        percent: `${this.emptyStar}%`,
      }));
    },
    setStars(stars) {
      let fullStarsCounter = Math.floor(this.rating);
      return stars.map((item) => {
        const star = { ...item };
        if (fullStarsCounter !== 0) {
          star.raw = this.fullStar;
          star.percent = this.calcStarFullness(star);
          fullStarsCounter -= 1;
        } else {
          const surplus = Math.round((this.rating % 1) * 10) / 10; // Support just one decimal
          const roundedOneDecimalPoint = Math.round(surplus * 10) / 10;
          star.raw = roundedOneDecimalPoint;
          star.percent = this.calcStarFullness(star);
        }
        star.fullfillColor = this.getFullFillColor(star);
        return star;
      });
    },
    getFullFillColor(starData) {
      return starData.raw !== this.emptyStar
        ? this.allStyles.fullStarColor
        : this.allStyles.emptyStarColor;
    },
    calcStarFullness(starData) {
      return `${starData.raw * 100}%`;
    },
  },
};
